import request from '@/utils/request'


// 查询赛事报名投票信息列表
export function listCompetitionSignVote(query) {
  return request({
    url: '/platform/competition-sign-vote/list',
    method: 'get',
    params: query
  })
}

// 查询赛事报名投票信息分页
export function pageCompetitionSignVote(query) {
  return request({
    url: '/platform/competition-sign-vote/page',
    method: 'get',
    params: query
  })
}

// 查询赛事报名投票信息详细
export function getCompetitionSignVote(data) {
  return request({
    url: '/platform/competition-sign-vote/detail',
    method: 'get',
    params: data
  })
}

// 新增赛事报名投票信息
export function addCompetitionSignVote(data) {
  return request({
    url: '/platform/competition-sign-vote/add',
    method: 'post',
    data: data
  })
}

// 修改赛事报名投票信息
export function updateCompetitionSignVote(data) {
  return request({
    url: '/platform/competition-sign-vote/edit',
    method: 'post',
    data: data
  })
}

// 删除赛事报名投票信息
export function delCompetitionSignVote(data) {
  return request({
    url: '/platform/competition-sign-vote/delete',
    method: 'post',
    data: data
  })
}
